import React from "react";
import { OrderTransactionResponse } from "../../../../service/customer/order-workflow-service";
import { StatusTimeline } from "./StatusTimeline";
import styles from "../solar-journey.module.scss";

interface Props {
	data: OrderTransactionResponse;
}

export const OrderInfoSection: React.FC<Props> = ({ data }) => {
	const delivery = data.details.deliveryInformation;

	return (
		<>
			<div>
				<div className={styles.sectionTitle}>Order Details</div>
				<div className={styles.detailsCard} style={{ marginTop: 10 }}>
					<div className={styles.detailRow}>
						<span className={styles.detailLabel}>Order Number</span>
						<span className={styles.detailValue}>{data.details.id || "-"}</span>
					</div>
					<div className={styles.detailRow}>
						<span className={styles.detailLabel}>Delivery Address</span>
						<span className={styles.detailValue}>{delivery?.address || "-"}</span>
					</div>
					<div className={styles.detailRow}>
						<span className={styles.detailLabel}>Delivery Timeline</span>
						<span className={styles.detailValue}>-</span>
					</div>
				</div>
			</div>

			<div>
				<div className={styles.sectionTitle}>Status</div>
				<div style={{ marginTop: 10 }}>
					<StatusTimeline events={data.workflowDetails.events || []} />
				</div>
			</div>
		</>
	);
};
